import Cookies from 'js-cookie'
import { getRootDomain } from '../utils/getRootDomain.js'

const COOKIE_SRC = 'SRC'
const COOKIE_KEYWORDS = 'SRC-KW'

/**
 * Referrer tracking
 * Adapted from original theme js tracking code on previous website...
 */
const searchString = window.location.search.substring(1),
    nameValuePairs = searchString.split(/&/),
    _domain = getRootDomain(window.location.hostname)

const DOMAINS_NATURAL_SOCIAL = ['facebook.com', 't.co', 'pinterest.', 'linkedin.com', 'plus.google','instagram.com', 'tiktok.com'];

const cookie_settings = { expires: 30, domain: '.'+_domain};

if (searchString.length > 0) {
    for (let i = 0; i < nameValuePairs.length; i++) {
        const nameValuePair = nameValuePairs[i].split(/=/);
        let name = nameValuePair[0];
        let value = decodeURI(nameValuePair[1]);
        name = name.toLowerCase();

        let isSet = false
        //Look for different PPC parameters
        if (name === "gclid") {
            Cookies.set(COOKIE_SRC, 'PPC', cookie_settings)
            isSet = true
        } else if (name === "msclkid") {
            Cookies.set(COOKIE_SRC, 'PPC', cookie_settings)
            isSet = true
        } else if (name === "fbclid") {
            Cookies.set(COOKIE_SRC, 'SOCIAL PPC', cookie_settings)
            isSet = true
        } else if (name.includes("clid")) {
            Cookies.set(COOKIE_SRC, 'PPC', cookie_settings)
            isSet = true
        } else if (name === 'utm_source') {
            Cookies.set(COOKIE_SRC, value, cookie_settings)
            isSet = true
        } else if (name === 'utm_term') {
            Cookies.set(COOKIE_KEYWORDS, value, cookie_settings)
        }

        //Look for keyword parameter
        if (name === 'keyword') {
            if (typeof value !== 'undefined') {
                Cookies.set(COOKIE_KEYWORDS, decodeURI(value).toLowerCase(), cookie_settings)
            }
        } else if(isSet && typeof value !== 'undefined') { // otherwise fallback on setting based on SRC set
            Cookies.set(COOKIE_KEYWORDS, value, cookie_settings);
        }
    }
}

const src_cookie = Cookies.get(COOKIE_SRC)
if (
    (src_cookie === null || src_cookie === 'DIRECT') &&
    document.referrer !== '' &&
    document.referrer.indexOf(_domain) === -1
) {
    if (document.referrer.indexOf('google') > -1) {
        Cookies.set(COOKIE_SRC, 'ORGANIC', cookie_settings)
        Cookies.set(COOKIE_KEYWORDS, decodeURI(document.referrer), cookie_settings)
    } else if (document.referrer.indexOf('yahoo') > -1) {
        Cookies.set(COOKIE_SRC, 'ORGANIC', cookie_settings)
        Cookies.set(COOKIE_KEYWORDS, decodeURI(document.referrer), cookie_settings)
    } else if (document.referrer.indexOf('bing') > -1) {
        Cookies.set(COOKIE_SRC, 'ORGANIC', cookie_settings)
        Cookies.set(COOKIE_KEYWORDS, decodeURI(document.referrer), cookie_settings)
    } else if (DOMAINS_NATURAL_SOCIAL.some((x) => document.referrer.indexOf(x) > -1)) {
        Cookies.set(COOKIE_SRC, 'SOCIAL', cookie_settings)
        Cookies.set(
            COOKIE_KEYWORDS,
            decodeURI(new URL(document.referrer).toString()),
            cookie_settings,
        )
    } else {
        Cookies.set(COOKIE_SRC, 'REFERRER', cookie_settings)
        Cookies.set(COOKIE_KEYWORDS, decodeURI(document.referrer), cookie_settings)
    }
}

// Set default cookie
if (Cookies.get(COOKIE_SRC) === undefined) {
    Cookies.set(COOKIE_SRC, 'DIRECT', cookie_settings)
    Cookies.set(COOKIE_KEYWORDS, decodeURI(document.location), cookie_settings)
}
